import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

type Store = {
  hraListParams: {
    cusId: string | null,
    pageNum: number,
  },
  setHraListParams: (name: any, value: any) => void,

  hraList: [],
  setHraList: (by: []) => void,

  hraListCount: number,
  setHraListCount: (by: number) => void,

  targetInfo: [],
  setTargetInfo: (by: []) => void,
  targetSurvey: [],
  setTargetSurvey: (by: []) => void,

  questionsList: [],
  setQuestionsList: (by: []) => void,

  assignedUid: string,
  setAssignedUid: (by: string) => void,

  splitableTitleList: [],
  setSplitableTitleList: (by: []) => void,

  selected: string,
  setSelected: (by: string) => void,

  age: any,
  setAge: (by: any) => void,

  checked: number,
  setChecked: (by: number) => void,

  viewObject: {},
  setViewObject: (by: {}) => void,

  factorsOject: {},
  setFactorsOject: (by: {}) => void,

  familyOject: {},
  setFamilyOject: (by: {}) => void,

  integrateOject: {},
  setIntegrateOject: (by: {}) => void,

  resultOject: {},
  setResultOject: (by: {}) => void,


  clear: () => void
  /*  reservationId: string
    setReservationId: (by: string) => void*/
}

const useHraStore = create<Store>()(
  devtools(
    persist(
      (set) => ({
        hraListParams: { cusId: localStorage.getItem('userCusID'), pageNum: 0 },
        setHraListParams: (name: any, value: any) => set((state: any) => {
          state.hraListParams[name] = value;
          return {}
        }),

        hraList: [],
        setHraList: (by: []) => set((state) => ({ hraList: by })),

        hraListCount: 0,
        setHraListCount: (by: number) => set((state) => ({ hraListCount: by })),

        targetInfo: [],
        setTargetInfo: (by: []) => set((state) => ({ targetInfo: by })),
        targetSurvey: [],
        setTargetSurvey: (by: []) => set((state) => ({ targetSurvey: by })),

        // 평가 리스트
        questionsList: [],
        setQuestionsList: (by: []) => set((state) => ({ questionsList: by })),

        assignedUid: '',
        setAssignedUid: (by: string) => set((state) => ({ assignedUid: by })),

        splitableTitleList: [],
        setSplitableTitleList: (by: []) => set((state) => ({ splitableTitleList: by })),

        selected: '-1',
        setSelected: (by: string) => set((state) => ({ selected: by })),

        age: 0,
        setAge: (by: any) => set((state) => ({ age: by })),

        checked: 0,
        setChecked: (by: number) => set((state) => ({ checked: by })),

        // 종합 결과
        viewObject: {},
        setViewObject: (by: {}) => set((state) => ({ viewObject: by })),

        factorsOject: {},
        setFactorsOject: (by: {}) => set((state) => ({ factorsOject: by })),

        familyOject: {},
        setFamilyOject: (by: {}) => set((state) => ({ familyOject: by })),

        integrateOject: {},
        setIntegrateOject: (by: {}) => set((state) => ({ integrateOject: by })),

        resultOject: {},
        setResultOject: (by: {}) => set((state) => ({ resultOject: by })),

        clear: () => set((state) => ({
          hraList: [],
          hraListParams: { cusId: localStorage.getItem('userCusID'), pageNum: 0 },
          targetInfo: [],
          targetSurvey: [],
        })),

        Answerclear: () => set((state) => ({
          questionsList: [],
          assignedUid: '',
          splitableTitleList: [],
          selected: '-1',
          age: 0,
          checked: 0,
        })),

        Resultclear: () => set((state) => ({
          viewObject: {},
          factorsOject: {},
          familyOject: {},
          integrateOject: {},
          resultOject: {},
        })),
      }),

      { name: 'hraStore' },
    ),
  ),
)

export default useHraStore;
